import { render, staticRenderFns } from "./headerDropdown.vue?vue&type=template&id=052b888a&scoped=true&"
import script from "./headerDropdown.vue?vue&type=script&lang=js&"
export * from "./headerDropdown.vue?vue&type=script&lang=js&"
import style0 from "./headerDropdown.vue?vue&type=style&index=0&id=052b888a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b888a",
  null
  
)

export default component.exports